var React = require('react');

function Download (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M68.697 72.268H30.375a1.5 1.5 0 110-3h38.321a1.5 1.5 0 11.001 3zM49.536 62.095a1.5 1.5 0 01-1.5-1.5V24.991a1.5 1.5 0 113 0v35.604a1.5 1.5 0 01-1.5 1.5z","key":0}),React.createElement("path",{"d":"M49.535 62.852c-.346 0-.692-.119-.974-.359L32.686 48.929a1.5 1.5 0 011.948-2.282l14.824 12.665 12.655-12.587a1.5 1.5 0 112.115 2.127L50.593 62.415c-.291.29-.674.437-1.058.437z","key":1})]);
}

Download.defaultProps = {"height":"100","width":"100","viewBox":"0 0 100 100"};

module.exports = Download;

Download.default = Download;
